import React from 'react';
import { useHistory } from 'react-router-dom';

import { Grid } from '@material-ui/core';
import Card from 'components/Card';
import Button from 'components/Button';

const nfseImage = require('../../../assets/img/nfse-icon.png');
const nfeImage = require('../../../assets/img/nfe-icon.png');

export default function ProvisionalReceiptTypeSelection() {
  const history = useHistory();

  return(
    <Card title='Selecione qual será o fluxo de nota fiscal'>
      <Grid container>
        <Grid container xs={6} justify='center' style={{ padding: 5 }}>
          <div style={{ height: 150 }}>
            <img src={nfseImage} style={{ height: 'inherit' }} />
          </div>
        </Grid>
        <Grid container xs={6} justify='center' style={{ padding: 5 }}>
          <div style={{ height: 150 }}>
            <img src={nfeImage} style={{ height: 'inherit' }} />
          </div>
        </Grid>
      </Grid>
      <Grid container>
        <Grid xs={6} style={{ padding: 5 }}>
          <Button
            fullWidth
            type='button'
            color='success'
            onClick={() => history.push('/configuracoes-de-notas-fiscais')}
          >
            Nota fiscal de serviço (NFS-e)
          </Button>
        </Grid>
        <Grid xs={6} style={{ padding: 5 }}>
          <Button
            fullWidth
            type='button'
            color='success'
            onClick={() => history.push('/configuracoes-de-notas-fiscais-de-produto')}
          >
            Nota fiscal de produto (NFe)
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
}